import demoMode from './demoMode';
export default demoMode;



// WEBPACK FOOTER //
// ./src/services/demoMode/index.js